import { Menu } from "./menu.model";
 
// export const verticalMenuItems = []
export const verticalMenuItems = [
  new Menu(1, "Home", "dashboard", null, "home", null, false, 0),
  new Menu(2, "Master Data ", "master", null, "master-icon", null, true, 0),
  new Menu(3, "Pricing Engine ", "price", null, "price-icon", null, true, 0),
  new Menu(35, "Pricing Engine V2", "price-v2", null, "price-icon", null, true, 0),
  new Menu(
    36,
    "Act Size Factor",
    "price-v2/act-size-factor",
    null,
    "floor-factor",
    null,
    true,
    35,
    true
  ),
  new Menu(
    37,
    "Segment Factor",
    "price-v2/segment-factor",
    null,
    "segment",
    null,
    true,
    35,
    true
  ),
  new Menu(
    38,
    "Status Factor",
    "price-v2/status-factor",
    null,
    "opportunity_tier",
    null,
    true,
    35,
    true
  ),
  new Menu(
    39,
    "Unit Discount Factor",
    "price-v2/unit-discount-factor",
    null,
    "floor-factor",
    null,
    true,
    35,
    true
  ),
  new Menu(
    40,
    "Duration Factor",
    "price-v2/duration-factor",
    null,
    "duration",
    null,
    true,
    35,
    true
  ),
  new Menu(
    41,
    "Pricing Density Zip Mileage",
    "price-v2/pricing-density-zip-mileage",
    null,
    "zipcode",
    null,
    true,
    35,
    true
  ),
  new Menu(
    42,
    "Last Paid Price (LPP)",
    "price-v2/last-paid-price",
    null,
    "pricing_information",
    null,
    true,
    35,
    true
  ),
  new Menu(
    43,
    "Cost of Supplies",
    "price-v2/cost-of-supplies",
    null,
    "product",
    null,
    true,
    35,
    true
  ),
  new Menu(
    44,
    "Cost Variable By Branch",
    "price-v2/cost-variable-by-branch",
    null,
    "location",
    null,
    true,
    35,
    true
  ),
  new Menu(
    45,
    "Pricing Information",
    "price-v2/pricing-information",
    null,
    "pricing_information",
    null,
    true,
    35,
    true
  ),
  new Menu(
    49,
    "Campaign Margin",
    "price-v2/campaign-margin",
    null,
    "pricing_information",
    null,
    true,
    35,
    true
  ),
  new Menu(
    46,
    "Fence Pricing",
    "fence-pricing",
    null,
    "price-icon",
    null,
    true,
    0
  ),
  new Menu(
    47,
    "Stock Prices",
    "fence-pricing/stock-prices",
    null,
    "pricing_information",
    null,
    true,
    46,
    true
  ),
  new Menu(
    48,
    "Non Stock Prices",
    "fence-pricing/non-stock-prices",
    null,
    "pricing_information",
    null,
    true,
    46,
    true
  ),
  new Menu(4, "Rate Card", "rate-card", null, "rate-card-icon", null, true, 0),
  new Menu(24, "Upload", "file-upload", null, "upload", null, false, 0),
  new Menu(25, "Manage Permissions", "role-permissions", null, "role-permission-icon", null, false, 0),
  new Menu(26, "Export Files", "export-files", null, "file_export_icon", null, false, 0),
  // pricing engine sub menu
  new Menu(
    6,
    "Pricing Information",
    "price/pricing-information",
    null,
    "pricing_information",
    null,
    true,
    3,
    true
  ),
  new Menu(
    7,
    "Fee Agreement",
    "price/fee-agreement",
    null,
    "fee_agreement",
    null,
    true,
    3,
    true
  ),
  new Menu(
    8,
    "Opportunity Tier",
    "price/opportunity-tier",
    null,
    "opportunity_tier",
    null,
    true,
    3,
    true
  ),
  new Menu(
    20,
    "Zip code over-ride",
    "price/zipcode",
    null,
    "zipcode",
    null,
    true,
    3,
    true
  ),
  new Menu(
    9,
    "Peer Group Factor",
    "price/peer-group-factor",
    null,
    "peer",
    null,
    true,
    3,
    true
  ),
  new Menu(
    10,
    "Segment Factor",
    "price/segment-factor",
    null,
    "segment",
    null,
    true,
    3,
    true
  ),
  new Menu(
    11,
    "Tier Group Factor",
    "price/tier-group-factor",
    null,
    "tier-group",
    null,
    true,
    3,
    true
  ),
  new Menu(
    12,
    "Floor Factor",
    "price/floor-factor",
    null,
    "floor-factor",
    null,
    true,
    3,
    true
  ),
  new Menu(
    13,
    "Duration Factor",
    "price/duration-factor",
    null,
    "duration",
    null,
    true,
    3,
    true
  ),
 
  // rate card sub menu
  new Menu(
    14,
    "View Rate Card",
    "rate-card/view-rate-card",
    null,
    "view_rate_card",
    null,
    true,
    4,
    true
  ),
  new Menu(
    15,
    "Competitor",
    "rate-card/competitor",
    null,
    "competitor",
    null,
    true,
    4,
    true
  ),
    new Menu(
    16,
    "Volume",
    "rate-card/volume",
    null,
    "volume",
    null,
    true,
    4,
    true
  ),
    new Menu(
    29,
    "Median",
    "rate-card/median",
    null,
    "median",
    null,
    true,
    4,
    true
  ),

  // master data sub menu
  new Menu(17, "Region", "master/region", null, "region", null, true, 2, true),
  new Menu(
    18,
    "Pricing Rate Zone",
    "master/pricing-rate-zone",
    null,
    "master-icon",
    null,
    true,
    2,
    true
  ),
  new Menu(
    19,
    "Location",
    "master/location",
    null,
    "location",
    null,
    true,
    2,
    true
  ),
  new Menu(
    21,
    "Product",
    "master/product",
    null,
    "product",
    null,
    true,
    2,
    true
  ),
  new Menu(
    22,
    "Account",
    "master/account",
    null,
    "account",
    null,
    true,
    2,
    true
  ),
  new Menu(
    23,
    "Acquisition",
    "master/acquisition",
    null,
    "acquisition",
    null,
    true,
    2,
    true
  ),
  new Menu(
    27,
    "Permit Fee",
    "price/permit-fee",
    null,
    "permit-fee-icon",
    null,
    true,
    3,
    true
  ),
 
  new Menu(
    28,
    "Sales Area",
    "master/sales-area",
    null,
    "sales_area",
    null,
    true,
    2,
    true
  ),
  new Menu(
    33,
    "Pricing Territory",
    "master/pricing-territory",
    null,
    "master-icon",
    null,
    true,
    2,
    true
  ),
  new Menu(
    34,
    "Zip Territory",
    "master/zip-territory",
    null,
    "zipcode",
    null,
    true,
    2,
    true
  ),

  new Menu(
    30,
    "Pricing Validation",
    "price/pricing-validation",
    null,
    "pricing_validation",
    null,
    true,
    3,
    true
  ),

  // DB Sync - Non-production only (see NON_PRODUCTION_ONLY_MENU_IDS + MENU_ROLE_ACCESS_MAP)
  new Menu(31, "DB Sync", "db-sync", null, "retry-icon", null, false, 0),
  // Admin only — visibility: MENU_ROLE_ACCESS_MAP[32]; route: app.routes analytics
  new Menu(32, "Analytics", "analytics", null, "bar_chart", null, false, 0),
];
 
 